import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id DA7FB76D-58FA-4AED-9DF9-033E994AE000
 * name swap-vertical
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-vertical.svg
 * tags
 * - Arrow 
 */
export const SwapVerticalIcon = createSvgIcon(<><path d="M9,3L5,7H8V14H10V7H13M16,17V10H14V17H11L15,21L19,17H16Z" /></>, 'SwapVerticalIcon');
export default SwapVerticalIcon